
      export const versions = {
        commit: 'ce4d238055432f3b651f017ea10582523f895ffa',
        branch: 'HEAD'
      };
